/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFileImage: {
  name: 'file-image';
  data: string;
} = {
  name: 'file-image',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9.414c0-.081-.005-.162-.015-.242a1.004 1.004 0 0 0-.41-.99 1.99 1.99 0 0 0-.16-.182L14 2.586a1.986 1.986 0 0 0-.182-.161.999.999 0 0 0-.99-.41A2 2 0 0 0 12.586 2H6Zm12 12.92V10h-4a2 2 0 0 1-2-2V4H6v13.131l6.837-4.557a2 2 0 0 1 2.359.102L18 14.919ZM6 19.534V20h12v-2.52l-4.054-3.242L6 19.535ZM16.586 8 14 5.414V8h2.586ZM10 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" fill="currentColor"/></svg>`,
};
